import { Col, Input, FormGroup, Label } from 'reactstrap';
import { LeadsNewTabFiltersType } from '../../types/Leads';
import { LeadsNewTabFilters } from '../../constants';

type LeadsRadioFiltersProps = {
  tableLeadStageFilter: LeadsNewTabFiltersType;
  setTableLeadStageFilter: (filter: LeadsNewTabFiltersType) => void;
  t: (key: string) => string;
};
export const LeadsRadioFilters = ({
  tableLeadStageFilter,
  setTableLeadStageFilter,
  t,
}: LeadsRadioFiltersProps) => {
  return (
    <Col sm="12" className="py-2">
      <FormGroup className="radio radio-primary ps-0 " check>
        <ul className="radio-wrapper justify-content-start flex-no-wrap">
          {LeadsNewTabFilters.map((data) => {
            const isSelected = String(tableLeadStageFilter.id) === String(data.id);
            return (
              <li
                key={data.id}
                className={`p-0 ${isSelected ? 'active-filter' : ''}`}
                style={isSelected ? { backgroundColor: 'rgba(43,94,94,0.06)', borderRadius: 6 } : undefined}
              >
                <Input
                  role="button"
                  className="form-check-input "
                  type="radio"
                  name="radio-leads"
                  id={`radio-leads-${data.id}`}
                  value={data.value}
                  checked={String(tableLeadStageFilter.id) === String(data.id)}
                  onChange={() => setTableLeadStageFilter(data)}
                />
                <Label htmlFor={`radio-leads-${data.id}`} className="form-check-label" check>
                  <span>
                    <p>{t(`leads.table.${data.value}`)}</p>
                  </span>
                </Label>
              </li>
            );
          })}
        </ul>
      </FormGroup>
    </Col>
  );
};
